import React from 'react';
import { string } from 'prop-types';

import { ReactComponent as TempoLogo } from '~assets/tempo-logo.svg';
import styles from './styles.module.scss';

function Header({ className }) {
  return (
    <nav className={className}>
      <TempoLogo className={styles.logo} />
    </nav>
  );
}

Header.propTypes = {
  className: string,
};

export default Header;
